module.exports = __webpack_public_path__ + "static/img/contactfranchise2-mobile.4b25402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contactfranchise2-mobile.jpg
// module id = 73I5
// module chunks = 1